import { IUser } from "../user/IUser"
import { ITask } from "./ITask"
import { ITaskParent } from "./ITaskParent"
import { Teams } from "./ITeams"


export class Task implements ITask{
    
    _id:any
    type: string="task"
    task_url:string=""
    msg_url:string=""
    parent: ITaskParent | undefined
    date: Date = new Date()
    user!: IUser
    txt: string =""
    
    teams:Teams = new Teams()
    

}



